/**
 * Stable CSS class names for E2E — Schedule create/edit form.
 */
export const SC = {
    page: 'schedule-create-page',
    form: 'schedule-create-page__form',
    breadcrumbSection: 'schedule-create-page__breadcrumb-section',

    content: 'schedule-create-page__content',
    headerCard: 'schedule-create-page__header-card',
    headerRow: 'schedule-create-page__header-row',

    fieldName: 'schedule-create-page-input__name',
    fieldGroupControl: 'schedule-create-page-input__group-control',
    fieldGroupLabel: 'schedule-create-page-input__group-label',
    fieldGroupSelect: 'schedule-create-page-input__group-select',
    fieldGroupOption: 'schedule-create-page-input__group-option',

    methodControl: 'schedule-create-page-input__method-control',
    methodLabel: 'schedule-create-page-input__method-label',
    methodSelect: 'schedule-create-page-input__method-select',
    methodOption: 'schedule-create-page-input__method-option',

    fieldUrl: 'schedule-create-page-input__url',
    saveButton: 'schedule-create-page-input--button-save',

    tabsCard: 'schedule-create-page__tabs-card',
    tabs: 'schedule-create-page__tabs',
    tab: 'schedule-create-page__tab',
    tabLabel: 'schedule-create-page__tab-label',
    tabPanel: 'schedule-create-page__tab-panel',
} as const;

export const scCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

